import { TestList } from '@/ac/entities/test/TestList';
import { TitleButton } from '@/common/buttons/TitleButton';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback } from 'react';
import { EntityDetail } from '../../../common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '../../../common/entityFramework/entityForm/EntityForm';

export const SuiteDetail = () => {
  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'testTab',
      label: 'Tests',
      content: <TestList suiteId={entityObj.id} />,
    },
  ];

  const run = useCallback(() => {
    let job = {
      name: 'Suite',
      module: 'ac',
      entity: 'SUITE',
      entityId: entityObj.id,
      rsrcCode: 'SUITE_ACTION_PLUGIN',
      cat: 'TEST',
      queueExempt: true,
    };

    rsrc.save('skdr', 'JOB', job).then((job) => {
      rsrc.start(job.id);
    });
  }, [entityObj.id]);

  const augButtons = (buttons) => {
    buttons.push(
      <TitleButton icon={fas.faPlay} toolTip="Run Suite" onClick={run} />,
    );
  };

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
